import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { ForecastService } from "@app/forecasts/services/forecast.service";
import { DialogService } from "@progress/kendo-angular-dialog";
import { LoaderComponent } from "@progress/kendo-angular-indicators";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { IWellForecastValidationResult } from "../interfaces/iwell-forecast-validation-result";

@Component({
  selector: 'app-forecast-validation-cell-renderer',
  template: `
        @if (isNo) {
          <a (click)="onClick($event)" class="clickable-link">{{ value }}</a>
        }
        @if (!isNo) {
          <span>{{ value }}</span>
        }
        `,
  styles: [`
        .clickable-link {
            color: blue !important;
            text-decoration: underline !important;
            cursor: pointer;
        }
    `],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class PxdAgGridForecastValidationCellRendererComponent implements ICellRendererAngularComp {
  private dialogService = inject(DialogService);
  private forecastService = inject(ForecastService);

  public params: any;
  public value: string;
  public get isNo(): boolean {
    return this.value === "No";
  }

  agInit(params: any): void {
    this.params = params;
    this.value = params.valueFormatted ? params.valueFormatted : params.value;
  }

  refresh(params: any): boolean {
    return false;
  }

  public async onClick(event: Event) {
    event.preventDefault();
    let scenarioId = this.params.data.ScenarioId;
    let parentBuildId = this.params.context.parentBuildId;
    let ssn = this.params.data.Ssn;

    const dialogRef = this.dialogService.open({
      title: `Validation Results`,
      content: ForecastValidationDialogComponent,
      width: 600,
      actions: [
        { text: "Close" }
      ]
    });

    let results = await this.forecastService.getWellValidationErrors(scenarioId, ssn, parentBuildId);

    const dialogInstance = dialogRef.content.instance;
    dialogInstance.results = results;
  }
}

@Component({
  selector: 'app-forecast-validation-dialog',
  imports: [
    LoaderComponent,
  ],
  template: `
    @if (results == null) {
      <div>
        <kendo-loader type="converging-spinner" size="small"></kendo-loader>
      </div>
    }
    @if (results != null) {
      <div>
        <table class="forecast-validation-dialog-table">
          <thead>
            <tr>
              <th>Project Type</th>
              <th>Error Type</th>
              <th>Message</th>
            </tr>
          </thead>
          <tbody>
            @for (result of results; track result) {
              @for (error of result.Errors; track error; let isFirst = $first) {
                <tr>
                  @if (isFirst) {
                    <td [attr.rowspan]="result.Errors.length">{{ result.ProjectType }}</td>
                  }
                  <td>{{ error.ErrorType }}</td>
                  <td>{{ error.Message }}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    }
    `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .forecast-validation-dialog-table {
      border-collapse: collapse;
      text-align: left;
      width: 100%;
      background-color: #f3f4f6;
    }
    .forecast-validation-dialog-table thead tr {
      text-align: left;
      background-color: #f5f7f7;
    }
    .forecast-validation-dialog-table th,
    .forecast-validation-dialog-table td {
      padding: 12px 15px;
      border: thin solid #dddddd;
    }
    .forecast-validation-dialog-table tbody tr:nth-of-type(even) {
      background-color: #f3f4f6;
    }
  `],
})
export class ForecastValidationDialogComponent {
  readonly results: IWellForecastValidationResult[] = null;
}